<template>
  <div>
    <div class="box">
      <admin-box-item title="맞춤 제작 신청 상세페이지">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="신청자 이름">
              {{ value.name }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="이메일">
              {{ value.email }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="휴대전화번호">
              {{ value.phone }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="상담 가능시간" v-if="value.products.length===0">
              {{ value.counsel }}
            </admin-form-item>
            <admin-form-item label="문의 내용" v-else>
              {{ value.counsel }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.service_name">
            <admin-form-item label="서비스 이름">
              {{ value.service_name }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.service_id">
            <admin-form-item label="서비스 아이디">
              {{ value.service_id }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="가격">
              {{ value.price | currency }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.theme_name">
            <admin-form-item label="테마이름">
              {{ value.theme_name }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.product_name">
            <admin-form-item label="상품이름">
              {{ value.product_name }}
            </admin-form-item>
          </div>
          <!--<div class="column is-full" v-if="value.imgs.length>0">
            <admin-form-item label="상품 이미지">
              <div :style="imgField(value.imgs[0])"></div>
            </admin-form-item>
          </div>-->
          <div class="column is-full" v-if="value.products.length>0">
            <admin-form-item label="선택한 상품들">
              <div v-for="(prod, idx) in value.products" :key="'product-'+idx">
                <span>{{ prod.name }} 상품</span><!-- <span v-for="op in prod.options" v-if="op.type===1"> {{ op.price | currency }}</span>-->
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="메인 페이지 업로드 파일">
              <div class="columns is-multiline">
                <div v-for="(file,idx) in value.main_upload" :key="'file-'+idx" class="column is-3">
                  <div v-if="idx===0">
                    <div class="lp-title-greylight">이미지</div>
                    <img class="lp-download-img" :src="file">
                  </div>
                  <div v-if="idx===1">
                    <div class="lp-title-greylight">파일</div>
                    <a :href="file" target="_blank" download>
                      <i class="material-icons lp-folder-icon">folder</i>
                    </a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="상품 목록 페이지 업로드 파일">
              <div class="columns is-multiline">
                <div v-for="(file,idx) in value.product_upload" :key="'file-'+idx" class="column is-3">
                  <div v-if="idx===0">
                    <div class="lp-title-greylight">이미지</div>
                    <img class="lp-download-img" :src="file">
                  </div>
                  <div v-if="idx===1">
                    <div class="lp-title-greylight">파일</div>
                    <a :href="file" target="_blank" download>
                      <i class="material-icons lp-folder-icon">folder</i>
                    </a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="상품 상세 페이지 업로드 파일">
              <div class="columns is-multiline">
                <div v-for="(file,idx) in value.product_detail_upload" :key="'file-'+idx" class="column is-3">
                  <div v-if="idx===0">
                    <div class="lp-title-greylight">이미지</div>
                    <img class="lp-download-img" :src="file">
                  </div>
                  <div v-if="idx===1">
                    <div class="lp-title-greylight">파일</div>
                    <a :href="file" target="_blank" download>
                      <i class="material-icons lp-folder-icon">folder</i>
                    </a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.blank_page || value.blank_upload.length>0">
            <admin-form-item :label="`${blank_page} 페이지 업로드 파일`">
              <div class="columns is-multiline">
                <div v-for="(file,idx) in value.blank_upload" :key="'file-'+idx" class="column is-3">
                  <div v-if="idx===0">
                    <div class="lp-title-greylight">이미지</div>
                    <img class="lp-download-img" :src="file">
                  </div>
                  <div v-if="idx===1">
                    <div class="lp-title-greylight">파일</div>
                    <a :href="file" target="_blank" download>
                      <i class="material-icons lp-folder-icon">folder</i>
                    </a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.type">
            <admin-form-item label="타입">
              {{ value.type }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.status">
            <admin-form-item label="상태">
              {{ convertStatus(value.status, value.service_status) }}
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="value.service_status">
            <admin-form-item label="서비스 등록 여부">
              <span v-if="value.service_status===0">대기상태</span>
              <span v-else-if="value.service_status===1">서비스 등록</span>
              <span v-else-if="value.service_status===2">서비스 등록안함</span>
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import LpSortDropDown from '../../../module/common/LpSortDropDown'
  import LpInputText from '../../../module/common/LpInputText'
  import LpRadio from '../../../module/common/LpRadio'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../../module/common/LpModal.vue'
  import AdminFilter from "../../../module/admin/AdminFilter";
  import AdminTable from "../../../module/admin/AdminTable";

  export default {
    layout:'Main',
    components: {},
    data () {
      return {
        value: {}
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData(){
        this.$axios.get(this.getUrl(`launchpack/theme/request/${this.$route.query.id}`))
          .then(res=>{
            if(res.status===200){
              this.value = res.data;
            }
          })
      },
      convertStatus(status, service_status){
        let value = '';
        if (status===0) value = '신청미확인';
        else if (status===1) value = '신청확인';
        else if (status===2) value = '상담완료';
        else if(status===2 && service_status===1) value = '서비스등록'
        else if(status===2 && service_status===2) value = '상담완료'
        return value;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .lp-folder-icon
    font-size 54px

  .lp-title-greylight
    color: #777
    font-size 12px

  .lp-download-img
    width 60px
    height 60px
</style>
